import { HojyoMA_CacheContainerBase } from "./base/hojyoMA_CacheContainerBase";
import { HojyoMACacheViewModel } from "./hojyoMACacheViewModel";

export class HojyoMA_Seg4CacheContainer extends HojyoMA_CacheContainerBase {
    constructor(models: Array<HojyoMACacheViewModel>, dataYear: number, version: Date) {
        super(models, dataYear, version);
    }
}